import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppRoleManagement } from '../components/AppRoleManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/admin-setting')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: AdminSettingPage,
});

function AdminSettingPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0 px-2 pt-4">
        <h1 className="m-0 text-xl font-semibold text-primary">Admin Settings</h1>
        <p className="mt-1 text-sm text-text-secondary">
          Manage who can sign in to this application and what they are allowed to do.
        </p>
      </div>
      <div className="min-h-0 flex-1">
        <AppRoleManagement />
      </div>
    </div>
  );
}
